// Health metric card for the calendar sidebar "phone" preview (type 'H').
// Copy of the workouts module's HealthCard rendering the full UI; the value input is
// readOnly and the Complete button is display-only (interaction blocked by the overlay).
import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { BoxShadow } from '../../../../shared/GlobalStyles';

const Container = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 170px;
  align-items: center;
  box-shadow: ${BoxShadow};
  border-radius: 12px;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.surfaceElevated};
  padding: 12px;
`;

const StyledInput = styled('input')`
  font-family: 'Nunito Sans';
  font-weight: 600;
  font-size: 11px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  text-align: center;
  width: 80%;
  border-radius: 4px;
  height: 30px;
  margin-top: 15px;
  /* Inputs don't inherit either property, so both are set explicitly. */
  background: ${({ theme }) => theme.colors.surfaceInput};
  color: ${({ theme }) => theme.colors.text};
`;

const CompleteButton = styled('button')`
  width: 140px;
  height: 37px;
  border-radius: 40px;
  box-shadow: ${BoxShadow};
  border: ${(props) => (props.isWorkoutComplete ? '1px solid #00b371;' : `1px solid ${props.theme.colors.border}`)};
  margin-top: 20px;
  background: ${(props) => (props.isWorkoutComplete ? '#00b371;' : props.theme.colors.surface)};
`;

const InnerCompleteButton = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CompleteButtonText = styled('div')`
  font-size: 12px;
  margin-left: 10px;
  font-weight: 600;
  font-family: 'Nunito Sans';
  color: ${(props) => (props.isWorkoutComplete ? 'white' : props.theme.colors.text)};
`;

const ButtonContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const AdditionalInformationText = styled('div')`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  text-align: center;
`;

const CalendarHealthCard = ({ workoutObject }) => {
  const { colors } = useTheme();
  const valueField = workoutObject?.tableData?.[0]?.values?.[0];
  const value = valueField && (valueField.value || valueField.value === 0) ? valueField.value : '';
  const placeholder = valueField?.placeholder || '';

  return (
    <Container>
      <AdditionalInformationText>
        {`Enter current ${workoutObject?.exercise?.name || ''}`}
      </AdditionalInformationText>
      <StyledInput readOnly value={value} placeholder={placeholder} />
      <ButtonContainer>
        <CompleteButton type='button' isWorkoutComplete={workoutObject.fullyCompleted}>
          <InnerCompleteButton>
            <IcomoonReact
              iconSet={iconSet}
              size={15}
              icon='checkmark'
              color={!workoutObject.fullyCompleted ? colors.text : 'white'}
            />
            <CompleteButtonText isWorkoutComplete={workoutObject.fullyCompleted}>
              Complete
            </CompleteButtonText>
          </InnerCompleteButton>
        </CompleteButton>
      </ButtonContainer>
    </Container>
  );
};

CalendarHealthCard.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarHealthCard;
